export const paths = {
    home: "/",
    about: "/about",
    contact: "/contact",
    projects: "/projects",
    quotes: "/quotes",
    technologies: "/technologies",
    timeline: "/timeline",
    inspirations: "/inspirations",
};
